package com.example.positionahead.ui.components

import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun UploadCsvButton(
    onCsvLoaded: (String) -> Unit,
    modifier: Modifier,
    enabled: Boolean,
) {
    var inputElement by remember { mutableStateOf<HTMLInputElement?>(null) }

    DisposableEffect(Unit) {
        val input = document.createElement("input") as HTMLInputElement
        input.type = "file"
        input.accept = ".csv,text/csv"
        input.style.display = "none"
        input.onchange = {
            val file = input.files?.item(0)
            if (file != null) {
                val reader = FileReader()
                reader.onload = {
                    val content = reader.result?.toString().orEmpty()
                    if (content.isNotBlank()) onCsvLoaded(content)
                }
                reader.readAsText(file)
            }
        }
        document.body?.appendChild(input)
        inputElement = input
        onDispose {
            document.body?.removeChild(input)
        }
    }

    Button(
        onClick = { inputElement?.click() },
        modifier = modifier,
        enabled = enabled,
    ) {
        Text("Upload CSV File")
    }
}
